import React, { Component } from "react";
import MarketplaceHeader from '../home/MarketplaceHeader';
import SupportContainer from '../home/SupportContainer';
import ForgotPasswordContent from '../home/ForgotPasswordContent';
import MainLoader from '../home/MainLoader';


class ForgotPasswordPage extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		supportPageName: 'Forgot Password',
		supportPageApi: '/forgotpassword',
		userTypeFaqs: 1,
		showLoader: false
    }
	
}
 
componentDidMount(){

}

updateStateFromChild=(state)=>{
	this.setState(state);
}

  render() {
	 return (
		<div className="marketplace_container">
			<MarketplaceHeader updateStateFromChild={this.updateStateFromChild} chosenMenu={this.state.chosenMenu} showOptions={false}></MarketplaceHeader>
			<div className="marketplace_main login_marketplace">
				<ForgotPasswordContent updateStateFromChild={this.updateStateFromChild}></ForgotPasswordContent>
			</div>
			<SupportContainer supportPageName={this.state.supportPageName} supportPageApi={this.state.supportPageApi} userTypeFaqs={this.state.userTypeFaqs}></SupportContainer>
			{ this.state.showLoader && <MainLoader></MainLoader> }
		</div>
    );
  }
}
export default ForgotPasswordPage;
